import { IconLink } from '@xing-com/icons';

import * as Styled from '../styles';
import type { ToolProps } from '../types';

export const LinkTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => {
        const previousUrl = editor.getAttributes('link').href;
        const url = window.prompt('URL', previousUrl);

        if (!url) {
          editor.chain().focus().extendMarkRange('link').unsetLink().run();
          return;
        }

        if (!/^https?:\/\/[a-zA-Z0-9-]+\.[a-zA-Z0-9]+/.test(url)) {
          editor.chain().focus().extendMarkRange('link').unsetLink().run();
          window.alert('Invalid URL');
          return;
        }

        const { state } = editor;
        const { from, to } = state.selection;
        const text = state.doc.textBetween(from, to, ' ');

        if (!text) {
          editor
            .chain()
            .focus()
            .insertContent(`<a href="${url}">${url}</a>`)
            .run();
        } else {
          editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({ href: url, target: '_blank' })
            .run();
        }
      }}
      disabled={
        disabled || !editor.can().chain().focus().toggleLink({ href: '' }).run()
      }
      className={editor.isActive('link') ? 'is-active' : ''}
    >
      <IconLink width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
